import script from "./TypeAheadBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TypeAheadBox.vue?vue&type=script&setup=true&lang=js"

import "./TypeAheadBox.vue?vue&type=style&index=0&id=b2e06b62&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2e06b62"]])

export default __exports__